import { formatInteger } from "@/helpers/utils";

// Subtract one value from another
export default function (first, second) {
  return formatInteger(first - second);
}
